module.exports = __webpack_public_path__ + "static/media/destiny.7aa63488.jpg";